import styled, { css } from "styled-components";
import { Atom } from 'AppReact';

const template = styled.img`
  ${({ theme }) => css`
    width: 33px;
    height: 33px;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid ${theme?.colour?.primary};
  `}
`;

export default Atom({ type: 'image', dataType: 'string', template });